import { bundles } from './data/index';
import { getRulesLanguage } from './preferences';
import { fill } from '../utils/game/logMessage';

export { fill };

const lookup = (text) => {
  const bundle = bundles[getRulesLanguage()];
  return bundle ? (bundle.locale.ui[text] ?? text) : text;
};

/**
 * Translate a UI string. Keys are the exact English source text. Missing
 * translations fall back to English. `{name}` placeholders are filled from
 * `values`. Call at render time, never at module scope, or the language the
 * app booted with sticks.
 */
export function t(text, values) {
  return fill(lookup(text), values, lookup);
}

/**
 * Mark an English string held in a module constant for later translation.
 * Returns it unchanged; `t()` translates it at render time. The extractor
 * collects `k` keys the same way it collects `t` keys.
 */
export const k = (text) => text;
